import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    headerTitleContainer: {
        position: "absolute",
        left: 0,
        right: 0
    },
    headerTitle: {
        alignSelf: "center"
    },
    profilePhotoWrapper: {
        alignSelf: "center"
    },
    profilePhotoImage: {
        width: 130,
        height: 130
    },
    photoEditButton: {
        position: "absolute"
    },
    actionButtonsContainer: {
        alignSelf: "center",
        flex: 1,
        width: "100%",
        alignContent: "center",
        alignItems: "center"
    },
    dialogHeaderContainer: {
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center"
    },
    dialogIconWrapper: {
        alignSelf: "center"
    },
    dialogTitle: {
        textAlign: "center"
    }
});
export default stylesheet;
